import resetScroll from 'teacher-ui-client/modifiers/reset-scroll'
import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'

export class ReportingUiScopeMathsPage extends Component {
  @service router!: RouterService

  get isDashboardTable() {
    return this.router.currentRouteName === 'reporting.ui-scope.maths.dashboard.table'
  }
  <template>
    <div
      class="{{if this.isDashboardTable 'relative flex flex-col'}} w-full"
      {{resetScroll onSetup=true onRouterChange=true}}
    >
      {{outlet}}
    </div>
  </template>
}

export default RouteTemplate(ReportingUiScopeMathsPage)
